var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"settings-content",class:{'settings-content__with-main-container' : _vm.isDeeplinksPage}},[(!_vm.isDeeplinksPage)?_c('HeadSection',{attrs:{"title":_vm.title,"permissionOfSection":"deeplinks"}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }